/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopBudgetByTenant {
    getFixupPrototypeFunction() { return TopBudgetByTenant.fixupPrototype; }

    static newInstance(model: Partial<TopBudgetByTenant>): TopBudgetByTenant {
        let obj = Object.assign(new TopBudgetByTenant(), model);
        TopBudgetByTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopBudgetByTenant>): TopBudgetByTenant {
        if (!model) return null;
        return TopBudgetByTenant.newInstance(<TopBudgetByTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopBudgetByTenant) {
        if (!obj) return;

        models.TopBudgetByTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopBudgetByTenant): boolean {
        Object.setPrototypeOf(obj, TopBudgetByTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_details) {
            for (let val of this.budget_details) {
                models.Budget.fixupPrototype(val);
            }
        }
    }

    tenant_id: string;

    budget_details: Array<models.Budget>;

}
